var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7101 11.29L12.7101 2.29C12.3201 1.9 11.6901 1.9 11.3001 2.29L2.30007 11.29C1.91007 11.68 1.91007 12.31 2.30007 12.7L11.3001 21.7C11.6901 22.09 12.3201 22.09 12.7101 21.7L21.7101 12.7C22.1001 12.32 22.1001 11.69 21.7101 11.29ZM14.0001 14.5V12H10.0001V15H8.00007V11C8.00007 10.45 8.45007 10 9.00007 10H14.0001V7.5L17.5001 11L14.0001 14.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionNavigation);
export default __webpack_public_path__ + "static/media/ic_action_navigation.affeb6fb1d29325e1c669b1d9422eaca.svg";
export { ForwardRef as ReactComponent };